export const ClicSanteThemeVariables = {
  letterSpacing: 'normal'
}
